import { initComponent } from './core/init-component';

initComponent('.js-ls-input-button', (el) => {
  const field = el.querySelector<HTMLElement>('.js-ls-input-button__field')!;
  const label = el.querySelector<HTMLLabelElement>('.js-ls-input-button__label')!;
  const input = el.querySelector<HTMLInputElement>('.js-ls-input-button__input')!;
  const error = el.querySelector<HTMLElement>('.js-ls-input-button__error')!;

  function activate() {
    label.classList.remove('text-f3', 'md:text-f2');
    label.classList.add('text-f4');
    field.classList.remove('gap-0', 'pb-4');
    field.classList.add('gap-4', 'pb-2');
    input.classList.remove('hidden');
  }

  function deactivate() {
    label.classList.remove('text-f4', 'hidden');
    label.classList.add('text-f3', 'md:text-f2');
    field.classList.remove('gap-4', 'pb-2', 'shadow-[inset_0_0_0_1px_var(--color-border-error)]');
    field.classList.add('gap-0', 'pb-4');
    input.classList.add('hidden');
    error.classList.add('hidden');
  }

  function showError() {
    label.classList.add('hidden');
    error.classList.remove('hidden');
    field.classList.add('shadow-[inset_0_0_0_1px_var(--color-border-error)]');
  }

  function hideError() {
    label.classList.remove('hidden');
    error.classList.add('hidden');
    field.classList.remove('shadow-[inset_0_0_0_1px_var(--color-border-error)]');
  }

  function isValidEmail(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function onInput() {
    if (!error.classList.contains('hidden') && isValidEmail(input.value.trim())) {
      hideError();
    }
  }

  function onFieldClick() {
    activate();
    input.focus({ preventScroll: true });
  }

  function onFocus() {
    activate();
  }

  function onBlur() {
    const value = input.value.trim();
    if (!value) {
      deactivate();
      return;
    }
    if (!isValidEmail(value)) {
      showError();
    } else {
      hideError();
    }
  }

  function onShowError() {
    activate();
    showError();
  }

  field.addEventListener('click', onFieldClick);
  input.addEventListener('focus', onFocus);
  input.addEventListener('blur', onBlur);
  input.addEventListener('input', onInput);
  el.addEventListener('ls-input-button:show-error', onShowError);

  return {
    unload() {
      field.removeEventListener('click', onFieldClick);
      input.removeEventListener('focus', onFocus);
      input.removeEventListener('blur', onBlur);
      input.removeEventListener('input', onInput);
      el.removeEventListener('ls-input-button:show-error', onShowError);
    },
  };
},{
  deferred: false,
});
